(function(){
  'use strict';
  var $ = function(s, c){ return (c || document).querySelector(s); };
  var $$ = function(s, c){ return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var body = document.body;
  var desk = window.matchMedia('(min-width: 990px)');
  var hoverDesk = window.matchMedia('(hover: hover) and (min-width: 990px)');
  window.NB = window.NB || {};
  function onChange(mq, fn){ if(mq.addEventListener) mq.addEventListener('change', fn); else if(mq.addListener) mq.addListener(fn); }

  /* ---------- header: hidden on the way down, back on the way up ---------- */
  function initHeader(){
    var hd = $('[data-hd]');
    if(!hd || hd.__nb) return; hd.__nb = true;
    var shell = hd.parentElement;
    var last = window.scrollY, ticking = false, t = 0;
    var trig = $('[data-mega-trigger]', hd), mega = $('[data-mega]', hd);
    var burger = $('[data-burger]', hd), mm = $('[data-mm]'), back = $('[data-mm-close]');

    function openMega(){ if(!mega || !desk.matches) return; clearTimeout(t); hd.classList.add('is-mega'); mega.setAttribute('aria-hidden', 'false'); if(trig) trig.setAttribute('aria-expanded', 'true'); }
    function closeMega(){ if(!mega) return; clearTimeout(t); hd.classList.remove('is-mega'); mega.setAttribute('aria-hidden', 'true'); if(trig) trig.setAttribute('aria-expanded', 'false'); }
    NB.closeMega = closeMega;

    function update(){
      ticking = false;
      var y = window.scrollY;
      var top = shell.getBoundingClientRect().top + y;
      var bottom = top + shell.offsetHeight;
      if(body.classList.contains('nb-mm-open')){ last = y; return; }
      if(y <= top + 1){
        hd.classList.remove('is-pinned', 'is-away');
      } else if(y < last - 3){
        if(y > bottom + 30 && !hd.classList.contains('is-pinned')){
          hd.classList.add('no-anim', 'is-pinned', 'is-away');
          void hd.offsetWidth;
          hd.classList.remove('no-anim');
        }
        if(hd.classList.contains('is-pinned')) hd.classList.remove('is-away');
      } else if(y > last + 3){
        if(hd.classList.contains('is-pinned')) hd.classList.add('is-away');
        closeMega();
      }
      last = y;
    }
    window.addEventListener('scroll', function(){
      if(ticking) return;
      ticking = true;
      if(document.hidden) update(); else requestAnimationFrame(update);
    }, {passive: true});

    if(trig && mega){
      trig.addEventListener('mouseenter', function(){ clearTimeout(t); t = setTimeout(openMega, 60); });
      trig.addEventListener('focus', openMega);
      $$('.nb-hd__link', hd).forEach(function(l){ if(l !== trig) l.addEventListener('mouseenter', function(){ clearTimeout(t); t = setTimeout(closeMega, 100); }); });
      hd.addEventListener('mouseleave', function(){ clearTimeout(t); t = setTimeout(closeMega, 220); });
      mega.addEventListener('mouseenter', function(){ clearTimeout(t); });
      hd.addEventListener('focusout', function(e){ if(!hd.contains(e.relatedTarget)) closeMega(); });
    }

    function setMM(open){
      if(!mm || !burger) return;
      if(open){
        var r = hd.getBoundingClientRect();
        document.documentElement.style.setProperty('--mm-top', Math.max(r.bottom, 0) + 8 + 'px');
      }
      body.classList.toggle('nb-mm-open', open);
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
      burger.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
      mm.setAttribute('aria-hidden', open ? 'false' : 'true');
    }
    NB.closeMenu = function(){ setMM(false); };
    if(burger) burger.addEventListener('click', function(){ setMM(!body.classList.contains('nb-mm-open')); });
    if(back) back.addEventListener('click', function(){ setMM(false); });
    if(mm) mm.addEventListener('click', function(e){
      if(e.target.closest('[data-quick-add]')){ setTimeout(function(){ setMM(false); }, 700); return; }
      if(e.target.closest('a')) setMM(false);
    });
    document.addEventListener('click', function(e){ if(e.target.closest('[data-open]')){ setMM(false); closeMega(); } }, true);
    document.addEventListener('keydown', function(e){ if(e.key === 'Escape'){ setMM(false); closeMega(); } });
    onChange(desk, function(){ setMM(false); closeMega(); });
    update();
  }

  /* ---------- add several products at once ---------- */
  document.addEventListener('click', function(e){
    var b = e.target.closest('[data-multi-add]');
    if(!b) return;
    e.preventDefault();
    var items = (b.getAttribute('data-multi-add') || '').split(',').filter(Boolean).map(function(i){ return {id: parseInt(i, 10), quantity: 1}; });
    if(!items.length || !NB.addItems) return;
    b.classList.add('is-loading');
    NB.addItems(items).then(function(){ return NB.refreshCart(true); })
      .catch(function(err){ alert((err && err.description) || 'Could not add to cart.'); })
      .then(function(){ b.classList.remove('is-loading'); });
  });

  /* ---------- skin match finder ---------- */
  function initMatch(root){
    if(root.__nb) return; root.__nb = true;
    var tabs = $$('[data-match-tab]', root), panels = $$('[data-match-panel]', root);
    function go(n){
      tabs.forEach(function(t, k){ t.classList.toggle('is-active', k === n); t.setAttribute('aria-selected', k === n ? 'true' : 'false'); });
      panels.forEach(function(p, k){ p.classList.toggle('is-active', k === n); });
    }
    tabs.forEach(function(t, k){
      t.addEventListener('click', function(){ go(k); });
      t.addEventListener('keydown', function(e){
        if(e.key === 'ArrowRight' || e.key === 'ArrowDown'){ e.preventDefault(); var n = (k + 1) % tabs.length; go(n); tabs[n].focus(); }
        if(e.key === 'ArrowLeft' || e.key === 'ArrowUp'){ e.preventDefault(); var m = (k - 1 + tabs.length) % tabs.length; go(m); tabs[m].focus(); }
      });
    });
    root.__go = go; root.__panels = panels;
  }

  /* ---------- ingredient explorer ---------- */
  function initChem(root){
    if(root.__nb) return; root.__nb = true;
    var items = $$('.nb-chem__item', root), t = 0;
    function go(n){
      items.forEach(function(it, k){ var on = k === n; it.classList.toggle('is-active', on); var b = $('[data-chem-tab]', it); if(b) b.setAttribute('aria-selected', on ? 'true' : 'false'); });
    }
    items.forEach(function(it, k){
      var b = $('[data-chem-tab]', it);
      if(!b) return;
      b.addEventListener('click', function(){ go(k); });
      b.addEventListener('mouseenter', function(){ if(!hoverDesk.matches) return; clearTimeout(t); t = setTimeout(function(){ go(k); }, 90); });
      b.addEventListener('mouseleave', function(){ clearTimeout(t); });
    });
    root.__go = go; root.__items = items;
  }

  /* ---------- shop the look ---------- */
  function closePins(except){ $$('[data-pin].is-open').forEach(function(p){ if(p !== except){ p.classList.remove('is-open'); var b = $('[data-pin-btn]', p); if(b) b.setAttribute('aria-expanded', 'false'); } }); }
  function placeCard(pin){
    var card = $('.nb-pin__card', pin);
    if(!card) return;
    var vw = document.documentElement.clientWidth;
    card.style.setProperty('--shift', '0px');
    if(window.innerWidth >= 750){
      if(!pin.__side) pin.__side = pin.classList.contains('nb-pin--l') ? 'l' : 'r';
      pin.classList.toggle('nb-pin--l', pin.__side === 'l');
      var r = card.getBoundingClientRect();
      if(pin.__side === 'r' && r.right > vw - 12) pin.classList.add('nb-pin--l');
      if(pin.__side === 'l' && r.left < 12) pin.classList.remove('nb-pin--l');
      return;
    }
    var m = card.getBoundingClientRect(), s = 0;
    if(m.left < 10) s = 10 - m.left; else if(m.right > vw - 10) s = vw - 10 - m.right;
    card.style.setProperty('--shift', s + 'px');
  }
  function initLook(root){
    if(root.__nb) return; root.__nb = true;
    $$('[data-pin]', root).forEach(function(pin){
      var btn = $('[data-pin-btn]', pin);
      function open(){ closePins(pin); placeCard(pin); pin.classList.add('is-open'); btn.setAttribute('aria-expanded', 'true'); }
      function close(){ pin.classList.remove('is-open'); btn.setAttribute('aria-expanded', 'false'); }
      btn.addEventListener('click', function(e){ e.stopPropagation(); if(pin.classList.contains('is-open')) close(); else open(); });
      pin.addEventListener('mouseenter', function(){ if(hoverDesk.matches) open(); });
      pin.addEventListener('mouseleave', function(){ if(hoverDesk.matches) close(); });
    });
  }
  document.addEventListener('click', function(e){ if(!e.target.closest('[data-pin]')) closePins(null); });

  /* ---------- product jobs: image follows the cursor a little ---------- */
  function initJobs(root){
    if(root.__nb) return; root.__nb = true;
    var img = $('.nb-jobs__img', root);
    if(!img || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    root.addEventListener('mousemove', function(e){
      if(!hoverDesk.matches) return;
      var r = root.getBoundingClientRect();
      var x = ((e.clientX - r.left) / r.width - .5) * 18, y = ((e.clientY - r.top) / r.height - .5) * 14;
      img.style.setProperty('--mx', x.toFixed(1) + 'px'); img.style.setProperty('--my', y.toFixed(1) + 'px');
    });
    root.addEventListener('mouseleave', function(){ img.style.setProperty('--mx', '0px'); img.style.setProperty('--my', '0px'); });
  }

  function initAll(scope){
    initHeader();
    $$('[data-match]', scope).forEach(initMatch);
    $$('[data-chem]', scope).forEach(initChem);
    $$('[data-look]', scope).forEach(initLook);
    $$('[data-jobs]', scope).forEach(initJobs);
  }
  initAll(document);

  document.addEventListener('shopify:section:load', function(e){ initAll(e.target); });
  document.addEventListener('shopify:block:select', function(e){
    var el = e.target;
    var m = el.closest && el.closest('[data-match]');
    if(m && m.__go && m.__panels){ var i = m.__panels.indexOf(el); if(i > -1) m.__go(i); }
    var c = el.closest && el.closest('[data-chem]');
    if(c && c.__go && c.__items){ var j = c.__items.indexOf(el); if(j > -1) c.__go(j); }
  });
})();
